import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useAnimations from '../../../hooks/useAnimations';
import FallbackCarDefault from '../../../assets/fallback_car_default.png';
import { device } from '../../../styles/devices';
import { StockCarTypes, Vehicle } from '../../../types';
import { SkeletonImage, SkeletonVehicle } from '../../Skeleton';
import ExposedHeader from '../ExposedHeader';
import {
  MobileWrapper,
  VehicleInfoContainer,
  ImageWrapper,
  VehicleImage,
  VehicleName,
  Trimline,
  Title,
} from '../VehicleInfo.styles';

interface VinSpecificVehicleProps {
  vehicle?: StockCarTypes;
  isVehicleLoading: boolean;
}

const VinSpecificVehicle: React.FC<VinSpecificVehicleProps> = ({ isVehicleLoading, vehicle }) => {
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ query: device.tablet });
  const [isOpen, setIsOpen] = useState(false);

  const dropdownHeigh = 382;
  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(isOpen, dropdownHeigh);
  const image = vehicle?.images[0]?.url ?? FallbackCarDefault;

  const modelName = vehicle?.titleText;
  const trimName = vehicle?.subtitleText;

  useEffect(() => {
    if (isTablet) setIsOpen(false);
  }, [isTablet]);
  return (
    <>
      {dropdownAnimation(
        (props, item) =>
          item && (
            <MobileWrapper style={props}>
              <VehicleInfoContainer style={filtersAccordianAnimation} data-testid="vehicle-info">
                <ImageWrapper data-testid="vehicle-info-image">
                  {isVehicleLoading ? (
                    <SkeletonImage data-testid="skeleton-image" />
                  ) : (
                    <VehicleImage src={image} />
                  )}
                </ImageWrapper>
                {isVehicleLoading ? (
                  <SkeletonVehicle data-testid="skeleton-vehicle" />
                ) : (
                  <>
                    <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
                    <Trimline>{trimName}</Trimline>
                  </>
                )}
              </VehicleInfoContainer>
            </MobileWrapper>
          ),
      )}
      {!isTablet && (
        <ExposedHeader isOpened={isOpen} setIsOpened={setIsOpen} modelName={modelName} />
      )}
      {isTablet && (
        <VehicleInfoContainer data-testid="vehicle-info-tablet">
          {isVehicleLoading ? (
            <SkeletonImage data-testid="skeleton-image" />
          ) : (
            <ImageWrapper data-testid="vehicle-info-image">
              <VehicleImage src={image} />
            </ImageWrapper>
          )}
          <Title paddingTop>{t('digitalLeads.vehicle.vehicleOfInterest')}</Title>
          {isVehicleLoading ? (
            <SkeletonVehicle data-testid="skeleton-vehicle" />
          ) : (
            <>
              <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
              <Trimline>{trimName}</Trimline>
            </>
          )}
        </VehicleInfoContainer>
      )}
    </>
  );
};

export default VinSpecificVehicle;
